import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';

// Capacitor injects window.Capacitor in native apps — no import needed.
// On web this is safely undefined, so optional chaining returns 'web'.
const platform = window?.Capacitor?.getPlatform?.() ?? 'web';
if (platform === 'ios') document.body.classList.add('ios-app');
if (platform === 'android') document.body.classList.add('android-app');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
